import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 0.25rem;
  font-size: 0.75rem;
`;
